import { h, Host, getAssetPath } from "@stencil/core";
export class ChStepListItem {
    constructor() {
        this.iconSrc = undefined;
    }
    /**
     * Emits the item id
     */
    itemClicked;
    el;
    ulStepItem;
    itemClickedHandler(item) {
        const targetItem = item.el.innerText;
        this.setActiveOption(targetItem);
        this.itemClicked.emit({ "item-clicked": targetItem });
    }
    setActiveOption(targetItem) {
        const parent = this.el.parentElement;
        const stepItems = parent.children;
        for (let i = 0; i < stepItems.length; i++) {
            const item = stepItems[i].shadowRoot.lastChild.childNodes[0];
            // remove old item selected class
            if (item.classList.contains("li-item--active")) {
                item.classList.remove("li-item--active");
            }
            // set active item class
            if (stepItems[i].innerText === targetItem) {
                item.classList.add("li-item--active");
            }
        }
    }
    resolveIcon() {
        if (this.iconSrc !== undefined) {
            return this.iconSrc;
        }
        else {
            return getAssetPath("step-list-item-assets/dot.svg");
        }
    }
    render() {
        return (h(Host, { class: "item", style: { width: "100%" } }, h("li", { class: {
            // "tree-open": this.opened,
            // disabled: this.disabled,
            } }, h("div", { class: {
                "li-item": true
                // "li-text--selected": this.selected,
            } }, h("span", { class: "text", onClick: () => this.itemClickedHandler(this) }, h("slot", null)), h("div", { class: "round-tab", onClick: () => this.itemClickedHandler(this) }, h("div", { part: "item-icon" })), h("span", { class: {
                "horizontal-line": true
            } })))));
    }
    static get is() { return "ch-step-list-item"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-step-list-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-step-list-item.css"]
        };
    }
    static get assetsDirs() { return ["step-list-item-assets"]; }
    static get properties() {
        return {
            "iconSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Set the left side icon"
                },
                "attribute": "icon-src",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "itemClicked",
                "name": "itemClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emits the item id"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=ch-step-list-item.js.map
